import { render, staticRenderFns } from "./RegisterService.vue?vue&type=template&id=021351d8&"
import script from "./RegisterService.vue?vue&type=script&lang=js&"
export * from "./RegisterService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports